const PicPayIcon = (props) => (
  <svg
    width={32}
    height={20}
    viewBox="0 0 32 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={32} height={20} rx={6} fill="#00CC65" />
    <path
      d="M10.5021 5.56791C10.9704 5.56181 11.4386 5.55658 11.907 5.55344C12.0659 5.55213 12.2248 5.55034 12.3836 5.54804C13.488 5.53247 14.5238 5.54175 15.5268 6.06585C15.57 6.0883 15.6132 6.11075 15.6578 6.13388C16.5604 6.62888 17.054 7.42341 17.3629 8.38041C17.4456 8.74191 17.4347 9.10847 17.4321 9.47737C17.4326 9.54799 17.4331 9.61861 17.4336 9.69136C17.4309 10.8062 17.0859 11.7864 16.3292 12.6173C15.4232 13.4819 14.2431 13.7449 13.0291 13.7389C12.9566 13.7389 12.8842 13.7388 12.8096 13.7387C12.5795 13.7383 12.3494 13.7375 12.1193 13.7366C11.9628 13.7363 11.8063 13.736 11.6498 13.7357C11.2672 13.7351 10.8846 13.7338 10.5021 13.7325C10.5021 14.7972 10.5021 15.8619 10.5021 16.9589C9.67638 16.9589 8.8507 16.9589 8 16.9589C8 13.8952 8 10.8314 8 7.6749C8.82568 7.6749 9.65136 7.6749 10.5021 7.6749C10.5021 6.97959 10.5021 6.28428 10.5021 5.56791Z"
      fill="#EDEFE6"
    />
    <path
      d="M18.9959 3C20.6472 3 22.2986 3 24 3C24 4.67309 24 6.34617 24 8.06996C22.3486 8.06996 20.6973 8.06996 18.9959 8.06996C18.9959 6.39687 18.9959 4.72379 18.9959 3Z"
      fill="#EAEFE5"
    />
    <path
      d="M10.5021 7.6749C10.9556 7.67083 11.4092 7.66675 11.8765 7.66256C12.0184 7.66076 12.1602 7.65896 12.3063 7.65711C12.4208 7.65653 12.5352 7.65603 12.6497 7.65561C12.7075 7.6546 12.7652 7.65359 12.8247 7.65255C13.4485 7.65229 14.0355 7.78962 14.4915 8.23895C14.8545 8.63566 15.0155 9.03374 15.0041 9.57614C15.0034 9.6224 15.0027 9.66865 15.0019 9.71631C14.9841 10.3007 14.8533 10.6904 14.4496 11.117C13.9317 11.5738 13.275 11.6462 12.6111 11.6384C12.5573 11.6382 12.5034 11.6381 12.448 11.638C12.2493 11.6373 12.0506 11.6355 11.8519 11.6338C11.4064 11.631 10.961 11.6283 10.5021 11.6255C10.5021 10.3218 10.5021 9.01811 10.5021 7.6749Z"
      fill="#00CC65"
    />
    <path
      d="M19.8519 3.85596C20.96 3.85596 22.0682 3.85596 23.2099 3.85596C23.2099 4.96411 23.2099 6.07226 23.2099 7.21399C22.1017 7.21399 20.9936 7.21399 19.8519 7.21399C19.8519 6.10584 19.8519 4.99769 19.8519 3.85596Z"
      fill="#01CC67"
    />
    <path
      d="M20.7078 4.71194C21.251 4.71194 21.7942 4.71194 22.3539 4.71194C22.3539 5.25515 22.3539 5.79836 22.3539 6.35804C21.8107 6.35804 21.2675 6.35804 20.7078 6.35804C20.7078 5.81483 20.7078 5.27162 20.7078 4.71194Z"
      fill="#EFF0E7"
    />
  </svg>
);
export default PicPayIcon;